import React from "react";
import { useMutation } from "@apollo/client";
import { Button } from "../../Button";
import {
  DealStatus_Enum,
  GetDealDocument,
  UpdateDealStatusDocument,
} from "../../../generated/graphql-operations";

export const ArchiveDealButton = ({ dealId }: { dealId: number }) => {
  const [updateDealStatus] = useMutation(UpdateDealStatusDocument);

  const handleButtonClick = async () => {
    await updateDealStatus({
      variables: { dealId, status: DealStatus_Enum.Archived },
      refetchQueries: [GetDealDocument],
    });
  };

  return (
    <Button
      variant="contained"
      onClick={handleButtonClick}
      sx={{
        backgroundColor: "#766B59",
        "&:hover": { backgroundColor: "#5C5346" },
      }}
    >
      Archive
    </Button>
  );
};
